export default {
  metaTitle: 'Manage Voucher Templates',
  pageTitle: 'Manage Voucher Templates',
  region: 'Region',
  BD: 'BD',
  columns1: 'ID',
  columns2: 'Name',
  columns3: 'Owner Type',
  columns4: 'Is Limit',
  columns5: 'Limit Min (Use condition)',
  columns6: 'Limit Amount',
  columns7: 'Personal Limit',
  columns8: 'Limit Type',
  columns9: 'Limit To',
  columns10: 'Status',
  ownerType1: 'Platform',
  ownerType2: 'Store',
  status1: 'Enable',
  status2: '禁用'
}
